import { Vector3 } from 'three'
import { PointOfViewDto } from '../dto/point-of-view.dto'
import { CameraConstraints } from './camera-constraints.object'
import ICameraConstraints from '../../../trillion-viewer/src/viewer/interfaces/camera-constraints.interface'

export class PointOfView {
  description = ''
  cameraPosition: Vector3 = new Vector3()
  lookAtPosition?: Vector3
  isFixedPointOfView?: boolean
  cameraConstraints?: CameraConstraints  

  constructor(pointOfViewDto: PointOfViewDto) {
    this.description = pointOfViewDto.description
    this.cameraPosition = new Vector3(
      pointOfViewDto.cameraPosition.x,
      pointOfViewDto.cameraPosition.y,
      pointOfViewDto.cameraPosition.z,
    )
    if (pointOfViewDto.lookAtPosition) {
      this.lookAtPosition = new Vector3(
        pointOfViewDto.lookAtPosition.x,
        pointOfViewDto.lookAtPosition.y,
        pointOfViewDto.lookAtPosition.z,
      )
    }
    if(pointOfViewDto.cameraConstraints) {
      this.cameraConstraints = new CameraConstraints(pointOfViewDto.cameraConstraints)
    }

    this.isFixedPointOfView = pointOfViewDto.isFixedPointOfView
  }
}


